import React, { useState } from "react";
import "./brand-data.scss";
import { Loading } from "../../../redux/action";
import { connect } from "react-redux";
import { Methods } from "../../../core/utility/methods";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { SortingColumnsType, TableComponent } from "../../../components/table-component/table";
import { Skeleton, TableCell, TableRow } from "@mui/material";
import { Card } from "../../../../src/components/tailwind-component/ui/card";
import { Avatar, AvatarImage } from "../../../../src/components/tailwind-component/ui/avatar";
import { AvatarFallback } from "@radix-ui/react-avatar";

interface Props{
  UserReducer: any;
  loading: (data: any) => void;
  profileEr:any;
  postFrequency:any;
  paidFrequency:any;
  organicFrequency:any;
  paidOrganicEr:any;
  paidOrganicImageVideoER:any;
  budget:any;
  dayRange:any;
  loader?:boolean
}
const methods = new Methods();
const columnDisplayName = {
    metrics: "Metrics",
    paid_posts: "Paid Posts",
    organic_posts: "Organic/Tagged Posts",
    brand_posts: "Brand Posts"
  };
  const sortingColumnType: SortingColumnsType[] = [
    {
      name: "metrics",
      columnSize: "90px",
    },
    {
      name: "paid_posts",
      columnSize: "70px",
    },    {
      name: "organic_posts",
      columnSize: "100px",
    },    {
      name: "brand_posts",
      columnSize: "100px",
    }      
  ];


  
   const influencerColors:any = {
    "Nano": "#FFA5CB",
    "Micro": "#FFD232",
    "Micro Plus": "#63ABFD",
    "Macro": "#1CF7C2",
    "Macro Plus": "#F45DCE",
    "Mega": "#6CDBF3",
    "Mega Plus": "#48B4CB"
  };
  const formatPercentage = (value?: number) => {
    return value != null ? `${value.toFixed(2)}%` : 'N/A';
  };
  
  const formatCountWithRange = (value?: number, dayRange?: number) => {
    return value != null && dayRange != null
      ? `${value.toFixed(0)} in last ${dayRange} days`
      : 'N/A';
  };
const MetricsCard: React.FC<Props> = (props: Props) => {
  const [renderData, setRenderData] = useState<any>([]);
  const PostFrequencyTableData = [
    {
      metrics: "ER - Overall",
      paid_posts: formatPercentage(props.paidOrganicEr?.[0]?.paid_er),
      organic_posts: formatPercentage(props.paidOrganicEr?.[0]?.brand_organic_er),
      brand_posts: formatPercentage(props.paidOrganicEr?.[0]?.brand_er),
    },
    {
      metrics: "ER - Static",
      paid_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.paid_image_er),
      organic_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.brand_organic_image_er),
      brand_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.brand_image_er),
    },
    {
      metrics: "ER - Videos",
      paid_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.paid_video_er),
      organic_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.brand_organic_video_er),
      brand_posts: formatPercentage(props.paidOrganicImageVideoER?.[0]?.brand_video_er),
    },
    {
      metrics: "Post Frequency",
      paid_posts: formatCountWithRange(props.postFrequency?.paid_post_value, props.dayRange),
      organic_posts: formatCountWithRange(props.postFrequency?.brand_organic_post_value, props.dayRange),
      brand_posts: formatCountWithRange(props.postFrequency?.brand_post_value, props.dayRange),
    }
]
  return (
    <>
  
    
    <div className="metrics-container">
      <p className="metrics-note">
        <MaterialSymbol iconName="info" fontSize="19px" color="#56B4EC"  fontweight="200" className="me-1" />
        The budgets, amount spent, EMV and ROI mentioned here are an approximation based on our algorithm from more than 7 data points.
      </p>
        <div className='row'>
          <div className='col-md-6'>
            <div className="metrics-grid">
              {props?.loader ?  <Skeleton variant="rectangular" height={77} style={{borderRadius:'6px'}} /> :
              <div className="metrics-item brand-insight-highchart">
                <div className="d-flex flex-column">
                  <h3>Budget</h3>
                  <div className="d-flex align-items-center">
                <img src="/likeIcon.png" alt="likeIcon" />
                <p className="compareInfo">Better than 80% of other Brands in your category</p>
                </div> 
                </div>
                <div className="valuesContainer">
                    <div className="d-flex flex-column me-auto">
                      <p className="value">INR 
                         {methods.formatNumberExactINR(props?.budget[0]?.total_amount/3)} </p>
                      <p className="subtext">Monthly</p>
                    </div>
                  <div className="d-flex flex-column ms-3">
                  <p className="value">INR {methods.formatNumberExactINR(props?.budget[0]?.total_amount*4)} </p>
                  <p className="subtext">Annually</p>
                  </div>
                
                  </div>
                
                
                {/* <p className="comparison">Better than 80% of other Brands in your category</p>*/}
              </div>
              }
              
              {props?.loader ?  <Skeleton variant="rectangular" height={77} style={{borderRadius:'6px'}} /> :
              <div className="metrics-item brand-insight-highchart">
                 <div className="d-flex flex-column">
                  <h3>Post Frequency</h3>
                 
                  <div className="d-flex align-items-center">
                <img src="/likeIcon.png" alt="likeIcon" />
                <p className="compareInfo">Better than 80% of other Brands in your category</p>
                </div>
                </div>
                <p className="value md-ms-auto mt-2 md-mt-0">{props?.postFrequency?.all_post_value?.toFixed(0)} <span className="fs-14 fw-400">in last {props.dayRange} days</span></p>
              </div>
              }
               {props?.loader ?  <Skeleton variant="rectangular" height={77} style={{borderRadius:'6px'}} /> :
                <div className="metrics-item brand-insight-highchart">
                                <div className="d-flex flex-column">
                                  <h3>ER</h3>
                                  <div className="d-flex align-items-center">
                                <img src="/likeIcon.png" alt="likeIcon" />
                                <p className="compareInfo">Better than 80% of other Brands in your category</p>
                                </div>
                                  
                                </div>
                                <p className="value md-ms-auto mt-2 md-mt-0">{props?.profileEr[0]?.engagement_rate?.toFixed(2)}%</p>
                </div>
                }
            </div>
          </div>
          <div className='col-md-6'>
          {props?.loader ?  <Skeleton variant="rectangular" height={'100%'} style={{borderRadius:'6px', marginBottom:'15px'}} /> :
            <TableComponent className="post-frequency-table brand-pulse-influencer-details-table d-block"
              tableMinWidth={500}
              pagination={false}
              columnDisplayName={columnDisplayName}
              inputDataSource={PostFrequencyTableData}
              orderByColumnName=""
              sortingColumnType={sortingColumnType}
              renderData={renderData}
              setRenderData={(e: any) => setRenderData(e)}
            > 
              {PostFrequencyTableData.map((data: any, index: number) => {
                return (
                  <TableRow key={index} >
                   <TableCell>{data.metrics}</TableCell>
                   <TableCell>{data.paid_posts}</TableCell>
                   <TableCell>{data.organic_posts}</TableCell>
                   <TableCell>{data.brand_posts}</TableCell>
                  </TableRow>
                );
              })}
            </TableComponent>
          }
          </div>
        </div>
    </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
    return {
      UserReducer: state.UserReducer.UserData,
    };
};
  
const mapDispatchToProps = (dispatch: any) => {
    return {
      loading: (data: any) => dispatch(Loading(data)),
    };
};
  
const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(MetricsCard);
  
export { connectToRedux as  MetricsCard };